export const SERVICE_ADDRESS = '0x9AF0092e737fC403161F318b7152f8a4244a2A5b'